import { translateColumns } from "../../../../../utils/tableUtils";

import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { useTranslation } from "react-i18next";
import { Modal, Table, TableColumnsType, TableProps } from "antd";
import { useAuthStore } from "../../../../../stores/stores";
import { ChangeEvent, useEffect, useState } from "react";
import FormItemInput from "../../../../../components/form-input/FormInput";
import { SearchOutlined } from "@ant-design/icons";
import { formatDateV2 } from "../../../../../utils/converDate";
import "./ManyApprovals.scss";
import TableData from "../../../../../components/table-data/TableData";
import { DataType } from "../../../../../types/listUsers";
import { getListAssign } from "../../../../../service/assign-course-construction";

import { ApprovalType } from "../../../../../types/survey-browse";

import { get, isEmpty } from "lodash";
import { HelpService } from "../../../../../service/helper.service";
import {
  approvalStatus,
  approvalStatusEum,
  courseStatusEum,
} from "../../constants/data";
import {
  approveManySurvey,
  postCoursePlanSearchAllAppraisal,
  postCoursePlanSearchAllApprove,
  postCoursePlanSearchApprove,
  postSurveySearchApprove,
} from "../../../../../service/course-plan-managment/mooc-approval-plan/mooc-approval-plan-api";
import { FilterDateCoursePlan } from "../../../../../types/course-plan-approval";
import Item from "antd/es/list/Item";
import {
  CrearteManyCoursePlanArroval,
  ManyCoursePlanArroval,
} from "../../../../../types/course-plan-managment/mooc-approval";

interface RowKeyType {
  id: number;
}
type Props = {
  open: boolean;
  handleCancel: () => void;
  listCourse: ManyCoursePlanArroval[];
};
export default function ManyApprovalsSurvey(props: Props) {
  const { t } = useTranslation();
  const { open, handleCancel, listCourse } = props;
  const userId = useAuthStore((states) => states.user?.id);
  const [searchValue, setSearchValue] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [listSurveyMany, setListSurveyMany] = useState<ManyCoursePlanArroval[]>(
    []
  );
  const helpService = new HelpService();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [filterData, setFilterData] = useState<FilterDateCoursePlan>({
    submissionDate: null,
    approvalDate: null,
  });
  const handleReturnStatus = (record: any) => {
    switch (record.survey_status) {
      case courseStatusEum.SAVE_DRAFT:
        return t("Bản nháp", "Bản nháp");
      case courseStatusEum.WAIT_APPROVE:
        return t("Chờ duyệt", "Chờ duyệt");
      case courseStatusEum.APPROVED:
        return t("Đã duyệt", "Đã duyệt");
      case courseStatusEum.REFUSE:
        return t("Từ chối", "Từ chối");
      case courseStatusEum.PUBLISHED:
        return t("Đã xuất bản", "Đã xuất bản");
      case courseStatusEum.END:
        return t("Kết thúc", "Kết thúc");
      default:
        return "";
    }
  };
  const dataColumns: TableColumnsType<any> = [
    {
      title: "STT",
      width: 10,
      render: (_: any, record, index: number) => {
        const orderNumber = (index + 1).toString().padStart(2, "0");
        return <span className="table-order-header">{orderNumber}</span>;
      },
    },
    {
      title: t("Tên kế hoạch xây dựng khóa học", "Tên kế hoạch xây dựng khóa học"),
      sorter: (a, b) => a.registrationName.localeCompare(b.registrationName),
      width: 60,
      dataIndex: "registrationName",
    },
    {
      title: t("Ngày gửi", "Ngày gửi"),
      width: 20,
      dataIndex: "submissionDate",
      render: (_: any, record) => {
        return (
          <>
            {record.submissionDate ? formatDateV2(record.submissionDate) : null}
          </>
        );
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      width: 30,
      dataIndex: "constructionPlanStatus",
      render: (_: any, record) => {
        return (
          <div className="table-status">
            <div
              className="color-icon"
              style={{
                backgroundColor: approvalStatus.filter(
                  (x) => x.value == record.constructionPlanStatus
                )[0]?.color,
              }}
            ></div>
            {
              approvalStatus.filter(
                (x) => x.value == record.constructionPlanStatus
              )[0]?.text
            }
          </div>
        );
      },
    },
  ];
  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
        ? "desc"
        : "";
    // setStatusOrder(data);
    // setFieldSortOrder(sorter.field);
  };
  useEffect(() => {
    if (open) {
      setListSurveyMany(listCourse);
      setLoading(false);
    }
  }, [open]);
  const onOk = () => {
    if (selectedRowKeys.length > 0) {
      const dataSend: CrearteManyCoursePlanArroval[] =
        // organzationId: listSurveyMany[0]?.organzationId ?? undefined,
        (selectedRowKeys as unknown as RowKeyType[]).map((i) => {
          let data = listSurveyMany.filter((x) => x.id == i.id);
          return {
            courseIds: data[0].courseConstructionPlanId,
            individualId: data[0]?.individualId ?? undefined,
            organzationId: data[0]?.organzationId ?? undefined,
            courseStatus: approvalStatusEum.APPROVED,
            submitterId: data[0]?.submitterId ?? undefined,
            userId: Number(userId),
          };
        });
      // courseStatus: approvalStatusEum.APPROVED,
      approveManySurvey(dataSend)
        .then((res) => {
          const { data, statusCode, message } = res.data;
          if (statusCode === 200) {
            helpService.successMessage(t("Thẩm định thành công", "Thẩm định thành công"));
            setTimeout(() => handleCancel(), 500);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      handleCancel();
    }
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);

    if (searchValue.trim() != "" || searchValue != null) {
      const data = listCourse.filter((item) => {
        return item.registrationName?.includes(value);
      });
      setListSurveyMany(data);
    }
  };
  const handleSubmitSearch = () => {
    // getListData(false);
  };
  const disableButton = selectedRowKeys.length === 0 ? true : false;

  return (
    <>
      <Modal
        title={t("Thẩm định nhiều kế hoạch khoá học", "Thẩm định nhiều kế hoạch khoá học")}
        centered
        open={open}
        okText={t("Xác nhận phê duyệt", "Xác nhận phê duyệt")}
        cancelText={t("Huỷ", "Huỷ")}
        onOk={onOk}
        onCancel={handleCancel}
        width={1000}
        okButtonProps={{ disabled: disableButton }}
      >
        <FormItemInput
          placeholder={t("Nhập từ khoá cần tìm", "Nhập từ khoá cần tìm")}
          value={searchValue}
          onChange={handleChangeInput}
          afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />}
        />
        <div className="title-custom-many-approval">
          <h1 className="title-custom-many-approval-h1">{t("Danh sách kế hoạch", "Danh sách kế hoạch")}</h1>
          <span className="title-custom-many-approval-span">({t("Đã chọn", "Đã chọn")} {selectedRowKeys.length}/{listSurveyMany.length} {t("kế hoạch", "kế hoạch")})</span>
        </div>
        <TableData
          dataTable={listSurveyMany}
          dataColumns={dataColumns}
          hideSelection={true}
          loadingTable={loading}
          setSelectedRowKeysProps={setSelectedRowKeys}
          handleTableChangeProps={handleTableChange}
        />
      </Modal>
    </>
  );
}
